export const holidayBundle = {
  theBestComicSubscription:
    "The best comic subscription, <1/> now with even more goodies",
  gcAlreadyGivesYouUnlimitedAccess:
    "GlobalComix Gold already gives you unlimited access to 100,000+ comics. <1/> This holiday, we’re making the deal even sweeter: Annual subscribers get 10 collectible books from top publishers.",
  becomeAGoldMember: "Become a Gold Member and claim your bundle",
  signUpNow: "Sign up Now",
  welcomeToGlobalComix: "Welcome to GlobalComix! ",
  youJustEarned: "You just received 10 free books!",
  yourHolidayBundleIsReady:
    "Your holiday bundle is ready to read in your library.",
};
